import { useState } from "react";

/**
 * Token 余额相关状态管理 Hook
 */
const useTokenState = () => {
  const [tokenBalance, setTokenBalance] = useState(null);
  const [tokenBalanceK, setTokenBalanceK] = useState(null);
  const [totalTokens, setTotalTokens] = useState(null);
  const [tokenGrant, setTokenGrant] = useState(null);
  const [planName, setPlanName] = useState(null);
  const [adminAdjustedBalance, setAdminAdjustedBalance] = useState(0);

  // 批量更新 token 状态
  const updateTokenState = (data) => {
    if (data.tokenBalance !== undefined) setTokenBalance(data.tokenBalance);
    if (data.tokenBalanceK !== undefined) setTokenBalanceK(data.tokenBalanceK);
    if (data.totalTokens !== undefined) setTotalTokens(data.totalTokens);
    if (data.tokenGrant !== undefined) setTokenGrant(data.tokenGrant);
    if (data.planName !== undefined) setPlanName(data.planName);
    if (data.adminAdjustedBalance !== undefined) setAdminAdjustedBalance(data.adminAdjustedBalance);
  };

  // 重置所有 token 状态
  const resetTokenState = () => {
    setTokenBalance(null);
    setTokenBalanceK(null);
    setTotalTokens(null);
    setTokenGrant(null);
    setPlanName(null);
    setAdminAdjustedBalance(0);
  };

  return {
    tokenBalance,
    setTokenBalance,
    tokenBalanceK,
    setTokenBalanceK,
    totalTokens,
    setTotalTokens,
    tokenGrant,
    setTokenGrant,
    planName,
    setPlanName,
    adminAdjustedBalance,
    setAdminAdjustedBalance,
    updateTokenState,
    resetTokenState,
  };
};

export default useTokenState;
